'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addConversation = undefined;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var addConversation = exports.addConversation = (0, _reduxActions.createAction)(ActionTypes.ADD_CONVERSATION, function (conversation) {
  return { conversation: conversation };
});